export let servFeatures = {
  hover: true,
  completion: true,
  signatureHelp: true,
  documentHighlight: true,
}
